import React, { Component } from 'react';
import Formulario from './SubirCuentasContablesForm';
import LoadMask from "../../Utils/LoadMask/LoadMask";

class SubirCuentasContables extends Component{
    state={
        archivo: null
    }

    componentDidMount = () => {
        const { listarEmpresas } = this.props;
        listarEmpresas();
    }
    
    setArchivo = (archivo) => {
        this.setState({archivo});
    };
    
    subirCuentasContables = (data) => {
        const { subirCuentasContables } = this.props;
        subirCuentasContables( {...data, archivo: null},
        [{ "file": this.state.archivo, "name": 'archivo' },])
    }

    render(){
        const { loader, listarEmpresas } = this.props;
    
        return(
            <LoadMask loading={loader} dark>
                <Formulario
                    onSubmit = {this.subirCuentasContables}
                    listarEmpresas = {listarEmpresas}
                    setArchivo={this.setArchivo} 
                />
            </LoadMask>
        );
    }
}

export default SubirCuentasContables
